import { render, staticRenderFns } from "./FaultRecord.vue?vue&type=template&id=3b316877&scoped=true"
import script from "./FaultRecord.vue?vue&type=script&lang=js"
export * from "./FaultRecord.vue?vue&type=script&lang=js"
import style0 from "./FaultRecord.vue?vue&type=style&index=0&id=3b316877&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b316877",
  null
  
)

export default component.exports